var path = 'public/app/plugins/app/example-app/legacy/angular_example_page.html';
var html = "\n\n<h3 class=page-heading>\n\tExample Page\n</h3>\n\n<p>this is in angular</p>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;